import { isVdMartLocation } from '../../utils/vdMartPOS';
import { addToCart, clearCart, requestBuyer } from './cartSlice';
import { getCachedProductList } from '../../utils/productCache';
import { normalizeLocation, resolveLocationCartProduct } from '../../utils/locationFinancials';

export const locationCartMiddleware = (store) => (next) => (action) => {
  if (action.type === 'posUser/login/fulfilled' || action.type === 'posUser/logout') {
    const cart = store.getState().cart;
    const location = normalizeLocation(action.payload?.location);
    if (!location || normalizeLocation(cart.location) !== location) store.dispatch(clearCart());
    const result = next(action);
    store.dispatch({ type: "products/hydrateFromCache" });
    return result;
  }
  if (action.type !== addToCart.type) return next(action);
  const state = store.getState();
  const location = normalizeLocation(state.posUser.userInfo?.location);
  const all = state.products.all;
  const products = Array.isArray(all) ? all : all?.products || [];
  try {
    if (isVdMartLocation(location) && !state.cart.buyer) { store.dispatch(requestBuyer(action.payload)); return; }
    if (isVdMartLocation(location) && state.products.loading) throw new Error('Wait for products to finish loading.');
    if (isVdMartLocation(location) && products.some(product => product.catalogSource !== 'ProductsVdMart')) throw new Error('Refresh the Vadaparru catalog.');
    if (isVdMartLocation(location) && !products.some(product => String(product._id) === String(action.payload.productId || action.payload.id) && product.details?.some(detail => String(detail._id) === String(action.payload.brandId) && detail.financials?.some(financial => String(financial._id) === String(action.payload.financialId))))) throw new Error('No local financials for this stakeholder and product. Refresh or select another product.');
    const payload = resolveLocationCartProduct(action.payload,
      products.length ? products : getCachedProductList(), location);
    if (state.cart.items?.length && normalizeLocation(state.cart.location) !== location) {
      store.dispatch(clearCart());
    }
    return next({ ...action, payload });
  } catch (error) {
    window.alert(error.message);
    return undefined;
  }
};
